// One switch for debug console traces: localStorage['solcheddar:debug'] = '1'
// (legacy localStorage.cheddarDebug = '1' also works).
// Re-read at most once a second, so the off path is a Date.now() compare.
let _on = false, _chk = 0
export function dbgOn() {
  const now = Date.now()
  if (now - _chk > 1000) {
    _chk = now
    try { _on = typeof localStorage !== 'undefined' && (localStorage.getItem('solcheddar:debug') === '1' || localStorage.getItem('cheddarDebug') === '1') } catch { _on = false }
  }
  return _on
}
// console.log that only prints when the debug switch is on.
export function dbg(...args) { if (dbgOn()) console.log(...args) }
